import { render, staticRenderFns } from "./CustomerMenu.vue?vue&type=template&id=640adb24&scoped=true&"
import script from "./CustomerMenu.vue?vue&type=script&lang=js&"
export * from "./CustomerMenu.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMenu.vue?vue&type=style&index=0&id=640adb24&prod&lang=css&"
import style1 from "./CustomerMenu.vue?vue&type=style&index=1&id=640adb24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640adb24",
  null
  
)

export default component.exports